// src/layouts/AppLayout.tsx
import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";

export const AppLayout = ({ children }: { children?: React.ReactNode }) => (
  <div>
    <Navbar />
    <div className="cpr-layout-inside">{children ? children : <Outlet />}</div>
  </div>
);
